import groupBy from 'lodash/groupBy'

import { Collection } from 'modules/core/lib/mobx-rest'

import type ApprovalGroup from 'modules/approvals/store/models/ApprovalGroup'
import ApprovalGroupMembership from 'modules/approvals/store/models/ApprovalGroupMembership'

class ApprovalGroupMemberships extends Collection<ApprovalGroupMembership> {
  get cacheKey(): string {
    return 'approvalGroupMemberships'
  }

  model() {
    return ApprovalGroupMembership
  }

  filterByApprovalGroup(approvalGroup: ApprovalGroup): ApprovalGroupMembership[] {
    const membershipsGroupedByGroup = groupBy(this.models, (e) => e.attributes.approval_group_id)

    return membershipsGroupedByGroup[approvalGroup.id] ?? []
  }

  async bulkAssign(
    accessIds: number[],
    approvalGroupId: number
  ): Promise<ApprovalGroupMembership[]> {
    const changedMemberships = (await this.rpc('bulk_assign', {
      approval_group_id: approvalGroupId,
      access_ids: accessIds,
    })) as ApprovalGroupMembership[]

    const toDelete = this.filter((model) => accessIds.includes(model.attributes.access_id))

    this.remove(toDelete)
    this.add(changedMemberships)

    return changedMemberships
  }
}

const singleton: ApprovalGroupMemberships = new ApprovalGroupMemberships()

export default singleton
